import { fetchData, API_TYPE } from '@umu/umu-fetch';
import { SWITCH_STATUS } from '@umu/umu-types';
import { getOperateSystemPlatformVersion } from '@umu/umu-ua';
/**
 * 资源下载打点日志
 */
const ADD_RESOURCE_LOG_URL = '/uapi/v1/resource/add-log';
/**
 * 资源下载打点日志 批量下载打点 数据接口
 */
const BATCH_ADD_RESOURCE_LOG_URL = '/uapi/v1/resource/batch-add-log';
/**
 * 扩展基础参数
 */
type ExpandBasicParams = Record<string, string>; // 平铺参数
const expandBasicParams: ExpandBasicParams = {};
/**
 * 枚举类型 操作类型
 */
enum EActionType {
    DOWNLOAD = 'download', // 下载
    UPLOAD = 'upload', // 上传
}
interface IConfigInfo {
    logUrl?: string; // 打点日志地址
}

/**
 * 枚举类型 来源类型
 */
enum EOriginType {
    MY_DOCUMENT = 1, // 我的文档
    MY_VIDEO = 2, // 我的音视频
    MICRO_PAGE = 3, // 微页面
    VIDEO_HOMEWORK = 4, // 视频作业
    MESSAGE_CENTER = 5, // 消息中心
    EXERCISE = 6, // 练习
    DOCUMENT_SESSION = 7, // 文档小节下载
    MESSAGE_CENTER_VIDEO = 8, // 消息中心视频
    USE_EXERCISE_VIDEO = 9, // 练习频道下的视频下载
    DOCUMENT_HOMEWORK = 10, // 文档作业
    DEPARTMENT_BOARD_HOMEWORK = 11, // 部门看板下作业下载
}
/*
 * 枚举类型 资源类型
 */
enum EResourceType {
    VIDEO = 1, // 视频
    DOCUMENT = 2, // 文档
    LIVE = 3, // 直播流
    IMG_TEXT = 4, // 图文微课
    AUDIO = 5, // 证书
}
/**
 * 打点日志基础参数
 */
interface ILogBasicParams {
    resource_type: EResourceType; // 资源类型
    origin_type: EOriginType; // 来源类型
    batch_operate?: SWITCH_STATUS; // 是否为批量操作
}
/**
 * 打点日志参数
 */
interface ILogParams extends IConfigInfo, ILogBasicParams {
    resource_id: string; // 资源id
    file_url: string; // 文件链接地址
    file_name: string; // 文件名称
    file_ext: string; // 文件扩展名
    action_type: EActionType; // 操作类型
    refer?: string; // 来源链接
    fetchOptions?: any;
    expandParams?: ExpandBasicParams;
}
/**
 * 下载资源参数映射(仅提供给下载资源打点使用，请勿新增不需要的字段)
 */
interface IResourceTypeMap {
    [key: string]: {
        resource_type: EResourceType;
        origin_type: EOriginType;
        batch_operate?: SWITCH_STATUS.YES;
        fetchOptions?: any;
        expandParams?: ExpandBasicParams;
    };
}
const resourceTypeMap: IResourceTypeMap = {
    docweike: {
        //我的文档
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.MY_DOCUMENT, // 我的文档
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    videoweike: {
        // 我的音视频
        resource_type: EResourceType.VIDEO, // 视频
        origin_type: EOriginType.MY_VIDEO,
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    /***我的课程作业*****start**/
    homework1: {
        //小节 ai 作业 -语音-批量
        resource_type: EResourceType.AUDIO, // 语音
        origin_type: EOriginType.VIDEO_HOMEWORK, // 图文作业
        batch_operate: SWITCH_STATUS.YES,
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    homework2: {
        //小节 ai 作业 -视频-批量
        resource_type: EResourceType.VIDEO, // 视频
        origin_type: EOriginType.VIDEO_HOMEWORK, // 视频作业
        batch_operate: SWITCH_STATUS.YES,
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    homework3: {
        //小节 ai 作业 -图文
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.VIDEO_HOMEWORK, // 图文作业
        batch_operate: SWITCH_STATUS.YES,
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    homework4: {
        //小节 ai 作业 -文档-批量
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.VIDEO_HOMEWORK, // 视频作业
        batch_operate: SWITCH_STATUS.YES,
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    homework5: {
        //小节 ai 作业 -批量
        resource_type: EResourceType.VIDEO, // 视频
        origin_type: EOriginType.VIDEO_HOMEWORK, // 语音作业
        batch_operate: SWITCH_STATUS.YES,
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    homework7: {
        //小节 ai 作业 -语音
        resource_type: EResourceType.AUDIO, // 语音
        origin_type: EOriginType.VIDEO_HOMEWORK, // 语音作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    homework11: {
        //小节 ai 作业 -视频
        resource_type: EResourceType.VIDEO, // 视频
        origin_type: EOriginType.VIDEO_HOMEWORK, // 视频作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    homework14: {
        //小节 ai 作业 -文档
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.VIDEO_HOMEWORK, // 视频作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },

    homework15: {
        //小节 ai 作业 -图文-批量
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.VIDEO_HOMEWORK, // 图文作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    /***我的课程作业*****end**/
    /****文档小节*****start**/
    session14: {
        // 文档
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.DOCUMENT_SESSION, // 我的文档
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    /***文档小节*****end**/
    /***部门看板作业*****start**/
    departmentBoardHomework1: {
        //小节 ai 作业 -语音-批量
        resource_type: EResourceType.AUDIO, // 语音
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 图文作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    departmentBoardHomework2: {
        //小节 ai 作业 -视频-批量
        resource_type: EResourceType.VIDEO, // 视频
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 视频作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },

    departmentBoardHomework3: {
        //小节 ai 作业 -图文
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 图文作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    departmentBoardHomework4: {
        //小节 ai 作业 -文档-批量
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 视频作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },

    departmentBoardHomework5: {
        //小节 ai 作业 -批量
        resource_type: EResourceType.VIDEO, // 视频
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 语音作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    departmentBoardHomework7: {
        //小节 ai 作业 -语音
        resource_type: EResourceType.AUDIO, // 语音
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 语音作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    departmentBoardHomework11: {
        //小节 ai 作业 -视频
        resource_type: EResourceType.VIDEO, // 视频
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 视频作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    departmentBoardHomework14: {
        //小节 ai 作业 -文档
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 视频作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },

    departmentBoardHomework15: {
        //小节 ai 作业 -图文-批量
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.DEPARTMENT_BOARD_HOMEWORK, // 图文作业
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    /***部门看板作业*****end**/
    /****微页面*****start**/
    microPage: {
        // 微页面
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.MICRO_PAGE, // 微页面
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    microPageMobile: {
        // 微页面
        resource_type: EResourceType.DOCUMENT, // 文档
        origin_type: EOriginType.MICRO_PAGE, // 微页面
        expandParams: {
            device_type: '2', // pc 消息类型平台信息 1: pc 端
        },
    },
    messageCenterVideo: {
        // 消息中心
        resource_type: EResourceType.VIDEO, // 文档
        origin_type: EOriginType.MESSAGE_CENTER_VIDEO, // 消息中心
        batch_operate: SWITCH_STATUS.YES,
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    /****微页面*****end**/
    /****练习频道下的视频下载*****start**/
    useExerciseVideo: {
        // 练习频道下的视频下载
        resource_type: EResourceType.VIDEO, // 视频
        origin_type: EOriginType.USE_EXERCISE_VIDEO, // 练习频道下的视频下载
        expandParams: {
            device_type: '1', // pc 消息类型平台信息 1: pc 端
        },
    },
    /****练习频道下的视频下载*****end**/
};
/**
 * 打点日志 参数打印
 */
const isDebug = window?.pageData?.config?.env === 'pd';
/**
 * 打点日志 参数打印
 */
const debugInfo = (...args: any[]) => {
    if (!isDebug) {
        return;
    }
    console.log('debugInfo ', ...args);
};
/**
 * 打点日志 添加资源日志 基础接口
 */
const addResourceBasicLog = async (params: ILogParams) => {
    const {
        logUrl = ADD_RESOURCE_LOG_URL,
        batch_operate = SWITCH_STATUS.NO,
        expandParams,
        fetchOptions,
        ...restParams
    } = params;
    if (batch_operate === SWITCH_STATUS.YES) {
        return addResourceBatchDownloadLog({ ...restParams, fetchOptions, expandParams });
    }
    const operateSystemPlatformVersion = await getOperateSystemPlatformVersion();
    debugInfo('operateSystemPlatformVersion = ', operateSystemPlatformVersion);

    return fetchData(
        {
            url: logUrl, // 根据资源id批量获取对应信息
            type: API_TYPE.GET,
        },
        { ...expandBasicParams, ...restParams, ...expandParams, os: operateSystemPlatformVersion },
        { silent: true, ...fetchOptions },
    ).then(
        (res: IResponse<boolean>) => {
            return res?.data || false;
        },
        () => {
            return false;
        },
    );
};
/**
 * 打点日志 添加资源日志 批量下载数据接口
 */
const addResourceBatchDownloadLog = async (params: ILogParams) => {
    const { logUrl = BATCH_ADD_RESOURCE_LOG_URL, fetchOptions, expandParams, ...restParams } = params;
    const operateSystemPlatformVersion = await getOperateSystemPlatformVersion();
    debugInfo('operateSystemPlatformVersion = ', operateSystemPlatformVersion);
    return fetchData(
        {
            url: logUrl, // 根据资源id批量获取对应信息
            type: API_TYPE.GET,
        },
        {
            id: restParams.resource_id,
            refer: restParams.refer,
            origin_type: restParams.origin_type,
            ...expandParams,
            os: operateSystemPlatformVersion,
        },
        { silent: true, ...fetchOptions },
    ).then(
        (res: IResponse<boolean>) => {
            return res?.data || false;
        },
        () => {
            return false;
        },
    );
};
export {
    EActionType,
    ILogParams,
    EResourceType,
    EOriginType,
    resourceTypeMap,
    ADD_RESOURCE_LOG_URL,
    addResourceBasicLog,
    addResourceBatchDownloadLog,
    debugInfo,
};
